import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {injectIntl} from 'react-intl';

import {closeThemeManager} from '../reducers/modals';
import {setTheme} from '../reducers/theme';
import {applyTheme} from '../lib/mstem-theme';
import {writeTheme} from '../lib/mstem-storage';

import ThemeManagerModalComponent from '../components/theme-manager-modal/theme-manager-modal.jsx';

class ThemeManagerModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleSelectTheme',
            'handleRequestClose'
        ]);
    }
    handleSelectTheme (themeId) {
        applyTheme(themeId);
        writeTheme(themeId);
        this.props.onSetTheme(themeId);
        // UX 2026-06-17: auto-close after picking so the user immediately sees the
        // re-themed IDE (header + backdrop) instead of the modal sitting open with
        // no apparent effect.
        this.props.onClose();
    }
    handleRequestClose () {
        this.props.onClose();
    }
    render () {
        return (
            <ThemeManagerModalComponent
                currentTheme={this.props.currentTheme}
                onRequestClose={this.handleRequestClose}
                onSelectTheme={this.handleSelectTheme}
            />
        );
    }
}

ThemeManagerModal.propTypes = {
    currentTheme: PropTypes.oneOf(['light', 'dark', 'cyan']).isRequired,
    onClose: PropTypes.func.isRequired,
    onSetTheme: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    currentTheme: state.scratchGui.theme.currentTheme
});

const mapDispatchToProps = dispatch => ({
    onClose: () => dispatch(closeThemeManager()),
    onSetTheme: themeId => dispatch(setTheme(themeId))
});

export default compose(
    injectIntl,
    connect(mapStateToProps, mapDispatchToProps)
)(ThemeManagerModal);
